import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  accountEmailById,
  avatarUrlById,
  fullNameById,
  isCoachById,
  orderCurrencyCodeById,
  orderCustomerActivatedOnDate,
  orderCustomerIdById,
  orderCustomerTypeIdById,
  orderCvById,
  orderDateById,
  orderQvById,
  orderStatusById,
  orderSubtotalConsumableById,
  orderTotalById,
  orderTypeById,
} from '/redux/selector/client.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import OrderSection from './OrderSection';

const withCustomerClientId = withProps({clientId: orderCustomerIdById});
const getCustomerRecordParams = ({
  customerId,
  customerTypeId,
  customerIsCoach,
}: any) => {
  const isCoach =
    customerTypeId === 1
      ? true
      : customerTypeId === 2
      ? false
      : customerIsCoach;

  return {[isCoach ? 'coachId' : 'clientId']: customerId};
};

export default connect(
  createStructuredSelector({
    customerId: orderCustomerIdById,
    customerTypeId: orderCustomerTypeIdById,
    orderType: orderTypeById,
    orderDate: orderDateById,
    orderStatus: orderStatusById,
    orderCv: orderCvById,
    orderQv: orderQvById,
    orderCurrencyCode: orderCurrencyCodeById,
    subtotalConsumable: orderSubtotalConsumableById,
    orderTotal: orderTotalById,
    customerIsCoach: withCustomerClientId(isCoachById),
    customerFullName: withCustomerClientId(fullNameById),
    customerActivatedOn: withCustomerClientId(orderCustomerActivatedOnDate),
    customerAvatarUrl: withCustomerClientId(avatarUrlById),
    customerEmail: withCustomerClientId(accountEmailById),
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
  null,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onViewProfile: () => {
      return ownProps.onViewProfile?.(getCustomerRecordParams(stateProps));
    },
    onViewOrderHistory: () => {
      return ownProps.onViewOrderHistory?.(getCustomerRecordParams(stateProps));
    },
  }),
)(OrderSection);
